import { render, staticRenderFns } from "./UserGroupView.vue?vue&type=template&id=00b0dcb7&"
import script from "./UserGroupView.vue?vue&type=script&lang=js&"
export * from "./UserGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports